// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4594":"ddb666414ab4ffce","4846":"d6c5bd5efd7cbf2c","4904":"a070c9513bea1763","6034":"893f568dfa33daf5","8648":"c96498935b3b3b6f"}[chunkId] + ".css";
};